import axios from 'axios';
import { useState, useCallback, useEffect } from 'react';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { useAtom, atom } from 'jotai';
import { es } from 'date-fns/locale';
import DOMPurify from 'dompurify';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var runtime_1 = /*#__PURE__*/createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    define(Gp, "constructor", GeneratorFunctionPrototype);
    define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    });
    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    define(Gp, iteratorSymbol, function () {
      return this;
    });
    define(Gp, "toString", function () {
      return "[object Generator]";
    });

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports);

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") {
      globalThis.regeneratorRuntime = runtime;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime);
    }
  }
});
/**
 * Prepara un base64 "crudo" para ser utilizado en link de descarga
 *
 * @param content : Contenido de un fichero en base64;
 * @param mimeType : Tipo del fichero, ej: application/pdf o image/png
 * @returns Contenido en base64 listo para ser usado en un link de descarga
 */

var prepareBase64 = function prepareBase64(content, mimeType) {
  return "data:" + mimeType + "; base64," + content;
};
/**
 * Descarga un fichero con un link virtual o previsualiza el fichero en una pestaña nueva
 *
 *
 * @param content : Contenido de un fichero en base64;
 * @param mimetype : Tipo del fichero, ej: application/pdf o image/png
 * @param filename : Nombre del fichero a descargar
 * @param open : Flag que determina si el fichero se va a visualizar o descargar
 * @returns void
 */


var fileDownload = function fileDownload(content, mimetype, filename, open) {
  if (!mimetype || !content) return {};
  var today = format(new Date(), 'yy-MM-dd_hh-mm-sss');
  var extension = mimetype.split('/')[1];
  var fallback = today + "." + extension;
  var url = prepareBase64(content, mimetype);

  if (open) {
    visualizeFile(content, mimetype);
  } else {
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename || fallback);
    document.body.appendChild(link);
    return link.click();
  }
};
/**
 * Previsualiza un fichero en una nueva pestaña a partir de un base64 "crudo"
 *
 * @param content : Contenido de un fichero en base64;
 * @param mimetype : Tipo del fichero, ej: application/pdf o image/png
 * @returns void
 */


var visualizeFile = function visualizeFile(content, mimetype) {
  if (!content || !mimetype) {
    return new Error('No se puede visualizar el documento');
  }

  var url = prepareBase64(content, mimetype);
  return fetch(url).then(function (res) {
    return res.blob();
  }).then(function (blob) {
    return URL.createObjectURL(blob);
  }).then(function (uril) {
    return window.open(uril);
  });
};
/**
 * Previsualiza un fichero en una nueva pestaña a partir de un blob
 *
 * @param blob : Blob del fichero
 * @param fallback : Mensaje (toast) a mostrar en caso de no existir el blob
 * @returns void
 */


var openBlobFile = function openBlobFile(blob, fallback) {
  if (!blob) {
    toast.warning(fallback || 'No se ha podido generar el documento');
    return;
  }

  var fileURL = URL.createObjectURL(blob);
  window.open(fileURL);
};
/**
 * Convierte un base64 a objeto File (ej: valores por defecto en un formulario -> Filepond component)
 *
 * @param content : Documento en base64;
 * @param filename : Nombre del documento
 * @param mimeType : Tipo de documento
 * @returns Objeto File | null
 */


var dataURLtoFile = function dataURLtoFile(content, filename, mimeType) {
  if (!content || !mimeType) return null;
  var bstr = window.atob(content);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, {
    type: mimeType
  });
};
/**
 * Descarga un Excel en base a un FileConfig
 *
 * @param fileConfig : Configuración del fichero [FileConfig]
 */


var base64ExcelDownload = function base64ExcelDownload(fileConfig) {
  var file = fileConfig.file,
      extension = fileConfig.extension;
  var link = getDownloadLink(fileConfig);
  var mimeType = getExcelMimetype(extension);

  if (mimeType) {
    link.href = prepareBase64(file, mimeType);
    appendAndClick(link);
  }
};
/**
 * Descarga un documento en base a un FileConfig
 *
 * @param fileConfig : Configuración del fichero [FileConfig]
 */


var fileBlobDownload = function fileBlobDownload(fileConfig) {
  var link = getDownloadLink(fileConfig);
  var url = window.URL.createObjectURL(new Blob([fileConfig.file]));
  link.href = url;
  appendAndClick(link);
};
/**
 * Abre una prestaña nueva con un documento
 *
 * @param fileConfig : Configuración del fichero [FileConfig]
 */


var fileLinkDownload = function fileLinkDownload(fileConfig) {
  var link = getDownloadLink(fileConfig);
  link.href = fileConfig.file;
  link.target = '_blank';
  appendAndClick(link);
};
/**
 * Obtiene un elemento anchor preparado para la descarga (no contiene documento)
 *
 * @param fileConfig : Configuración del fichero [FileConfig]
 */


var getDownloadLink = function getDownloadLink(fileConfig) {
  var fileName = fileConfig.fileName,
      extension = fileConfig.extension;
  var fallback = format(new Date(), 'yy-MM-dd_hh-mm-sss') + "." + extension;
  var link = document.createElement('a');
  link.setAttribute('download', fileName || fallback);
  return link;
};
/**
 * Inyecta un anchor en el dom y lo clickea
 *
 * @param link : HTMLAnchorElement
 */


var appendAndClick = function appendAndClick(link) {
  document.body.appendChild(link);
  link.click();
};
/**
 * Obtiene el MimeType correcto en base a una extensión para Excel
 *
 * @param extension : Extensiones permitidas de ficheros (ver definición FileExt)
 * @returns [String] Mimetype adecuado a la extensión del documento de tipo Excel
 */


var getExcelMimetype = function getExcelMimetype(extension) {
  if (!extension.includes('xls')) {
    toast.error('Formato de descarga inválido');
    return null;
  } else {
    switch (extension) {
      case 'xls':
        return 'application/vnd.ms-excel';

      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      default:
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }
  }
};
/**
 * Evalúa si un Array<File> excede un máximo de bytes
 *
 * @param maxCapacity : Tamaño máximo permitido en bytes
 * @param files : Objetos tipo File a evaluar
 * @returns [Boolean] Determina si se ha excedido el tamaño máximo permitido
 */


var filesSizeExceeded = function filesSizeExceeded(maxCapacity, files) {
  if (!(files != null && files.length)) return false;
  var filesSize = getFilesSize(files);
  return maxCapacity - filesSize <= 0;
};
/**
 * Devuelve el peso en bytes de un Array<File>
 *
 * @param files Objetos tipo File
 * @returns [Number] Tamaño total en bytes
 */


var getFilesSize = function getFilesSize(files) {
  if (!(files != null && files.length)) return 0;
  return files == null ? void 0 : files.reduce(function (size, current) {
    return size + current.size;
  }, 0);
};

var getKeyValue = function getKeyValue(key, obj) {
  return obj[key];
};

var createUrl = function createUrl(url, ep) {
  return "" + (url || '') + (ep || '');
};
/**
 * @description custom hook para realizar peticiones asíncronas
 * @param url
 * @param config
 * @param propertyKey
 * @param cancelToken
 * @param notifyError
 * @returns { loading, error, get, getFile }
 */


var useFetch = function useFetch(url, config, propertyKey, cancelToken, axiosInstance) {
  if (axiosInstance === void 0) {
    axiosInstance = axios;
  }

  var _useState = useState(null),
      error = _useState[0],
      setError = _useState[1];

  var _useState2 = useState(false),
      loading = _useState2[0],
      setLoading = _useState2[1];
  /**
   * Manejador de la petición.
   * @description monta la petición para ser usada en los métodos.
   */


  var handleApiCall = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(c) {
      var res;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoading(true);
              setError(null);

              if (!c) {
                _context.next = 10;
                break;
              }

              res = null;
              _context.next = 7;
              return axiosInstance.request(c);

            case 7:
              res = _context.sent;
              if (res && propertyKey) res = getKeyValue(propertyKey, res);
              return _context.abrupt("return", res);

            case 10:
              return _context.abrupt("return", {});

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              setError(_context.t0);
              return _context.abrupt("return", {});

            case 17:
              _context.prev = 17;
              setLoading(false);
              return _context.finish(17);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13, 17, 20]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), // eslint-disable-next-line react-hooks/exhaustive-deps
  [propertyKey]);
  var get = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(ep, methodConf) {
      var finalConfig, c;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              finalConfig = _extends({}, config, methodConf);
              c = _extends({}, finalConfig, {
                cancelToken: cancelToken,
                url: createUrl(url, ep),
                method: 'get'
              });
              return _context2.abrupt("return", handleApiCall(c));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }(), [config, cancelToken, handleApiCall, url]);
  var getFile = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(ep, methodConf) {
      var finalConfig, c, _yield$handleApiCall, data, content, mimeType, filename;

      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              finalConfig = _extends({}, config, methodConf);
              c = _extends({}, finalConfig, {
                cancelToken: cancelToken,
                url: createUrl(url, ep),
                method: 'get'
              });
              _context3.next = 4;
              return handleApiCall(c);

            case 4:
              _yield$handleApiCall = _context3.sent;
              data = _yield$handleApiCall.data;

              if (data) {
                content = data.content, mimeType = data.mimeType, filename = data.filename;
                fileDownload(content, mimeType, filename);
              }

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }(), [config, cancelToken, handleApiCall, url]);
  var post = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(ep, d, methodConf) {
      var finalConfig, c;
      return runtime_1.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              finalConfig = _extends({}, config, methodConf);
              c = _extends({}, finalConfig, {
                url: createUrl(url, ep),
                method: 'post',
                data: d
              });
              return _context4.abrupt("return", handleApiCall(c));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x6, _x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }(), [config, handleApiCall, url]);
  return {
    loading: loading,
    error: error,
    post: post,
    get: get,
    getFile: getFile
  };
};

var initValue = {};
var errorsAtom = /*#__PURE__*/atom(initValue);
/**
 * Realiza una acción por cada error almacenado en el átomo errorsAtom
 *
 * @param callback Función a ejecutar por cada error (normalmente setError de react-hook-form)
 * @returns Object: setErrors, función setter del átomo errorsAtom
 */

var useFormError = function useFormError(callback) {
  var _useAtom = useAtom(errorsAtom),
      errors = _useAtom[0],
      setErrors = _useAtom[1];

  useEffect(function () {
    return function () {
      setErrors(initValue);
    };
  }, []);
  useEffect(function () {
    Object.keys(errors || {}).forEach(function (errorKey) {
      if (callback) {
        callback(errorKey, {
          message: errors && errors[errorKey] || 'Campo incorrecto'
        });
      }
    });
  }, [errors]);
  return {
    setErrors: setErrors
  };
};
/**
 * Prepara Intl.NumberFormat para un idioma y una divisa
 *
 * @param locale Define el idioma para formatear
 * @param currency Tipo de moneda
 * @returns Intl.NumberFormat en el idioma y divisa seleccionada
 */


var formatCurrency = function formatCurrency(locale, currency) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency
  });
};
/**
 * Sustituye los comodines de la ruta por valores reales
 *
 * @param rawUrl Ruta con los comodines (en crudo)
 * @param params Objeto con las variables a sustituir
 * @returns Ruta con los comodines sustituídos
 */


var replaceURLParams = function replaceURLParams(rawUrl, params) {
  var replacers = Object.keys(params);
  return replacers.reduce(function (url, replacerKey) {
    return url.replace(":" + replacerKey, "" + params[replacerKey]);
  }, rawUrl);
};
/**
 * Transforma un JSON a FormData
 *
 * @param payload JSON de datos para convertir a FormData
 * @returns Datos JSON convertidos a FormData
 */


function buildFormData(payload) {
  var formData = new FormData();
  Object.keys(payload).forEach(function (key) {
    return formData.append(key, payload[key]);
  });
  return formData;
}
/**
 * Evalúa si un valor no booleano está vacío
 *
 * @param value Cualquier valor a evauluar de un formulario
 * @returns true si el valor está vacío, false si el valor contiene algo
 */


function emptyValue(value) {
  if (typeof value === 'string') {
    return !value.trim().length;
  }

  if (Array.isArray(value)) {
    var emptyArray = !value.length;
    if (emptyArray) return true;
    return value.every(function (value) {
      return emptyValue(value);
    });
  }

  if (!!value && typeof value === 'object') {
    return !Object.keys(value).length;
  }

  return value === undefined || value === null;
}
/**
 * Elimina todas las keys de objetos con valores null o undefined
 *
 * @param data JSON a limpiar de valores vacíos
 * @returns JSON limpio
 */


var cleanEmptyFields = function cleanEmptyFields(data) {
  var cleanedObj = {};
  Object.keys(data).forEach(function (key) {
    if (!emptyValue(data[key])) {
      if (Array.isArray(data[key])) {
        cleanedObj[key] = data[key].filter(function (item) {
          return !emptyValue(item);
        });
      } else {
        cleanedObj[key] = data[key];
      }
    }
  });
  return cleanedObj;
};
/**
 * Evalúa si un Dato es del tipo adecuado
 *
 * @param data Datos a evaluar
 * @param type Tipo de dato correcto
 * @returns True si el dato es del tipo inadecuado, False en caso contrario
 */


var wrongType = function wrongType(data, type) {
  return data === null || data === undefined || typeof data !== type;
};
/**
 * Detecta si un array de DataType contienen algún elemento del tipo inadecuado
 *
 * @param data Datos a evaluar
 * @param type Tipo de dato correcto
 * @returns True si algún elemento es del tipo inadecuado, False en caso contrario
 */


var wrongArray = function wrongArray(data, type) {
  var wrongArray = !!data && Array.isArray(data) && data.some(function (el) {
    return wrongType(el, type);
  });
  var wrongElement = !!data && wrongType(data, type);
  var result = !data || wrongArray || !Array.isArray(data) && wrongElement;
  return result;
};
/**
 * Transforma la primera letra de un string a mayúscula
 *
 * @param str Texto a transformar
 * @returns Texto transformado
 */


var capitalize = function capitalize(str) {
  if (typeof str !== 'string' || !str.length) return '';
  return "" + str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
};
/**
 * Transforma la primera letra de cada palabra de un string a mayúscula
 *
 * @param str Texto a transformar
 * @returns Texto transformado
 */


var capitalizePhrase = function capitalizePhrase(str) {
  if (typeof str !== 'string' || !str.length) return '';
  return str.split(' ').map(function (word) {
    return capitalize(word);
  }).join(' ');
};
/**
 * Sesga un texto con puntos suspensivos (por defecto length 20)
 *
 * @param str Texto a transformar
 * @param length Número a partir del cual se realiza el sesgo
 * @returns Texto transformado
 */


var ellipsis = function ellipsis(str, length) {
  if (length === void 0) {
    length = 20;
  }

  if (wrongType(str, 'string')) return '';
  return (str == null ? void 0 : str.length) > length ? str.slice(0, length) + "..." : str;
};
/**
 * Une 2 strings con un pipe ( | )
 *
 * @param strA Primera cadena de texto
 * @param strB Segunda cadena de texto
 * @returns Cadenas de texto unidas
 */


var pipeStrings = function pipeStrings(strA, strB) {
  if (!strA && !strB) return '';
  if (!strA) return strB;
  if (!strB) return strA;
  return strA + " | " + strB;
};
/**
 * Sesga un texto con puntos suspensivos únicamente si no contiene espacios (maxLength por defecto 40)
 *
 * @param str Texto a transformar
 * @param maxLength Número a partir del cual se realiza el sesgo
 * @returns Texto transformado
 */


var nonSpaceEllipsis = function nonSpaceEllipsis(str, maxLength) {
  if (maxLength === void 0) {
    maxLength = 40;
  }

  if (!str || wrongType(str, 'string')) return '';
  var shouldEllipse = !str.includes(' ');

  if (shouldEllipse) {
    return ellipsis(str, maxLength);
  }

  return str;
};
/**
 * Obtiene los bytes que ocupa un string
 *
 * @param str String a evaluar
 * @returns Peso en bytes del string
 */


var getStringSize = function getStringSize(str) {
  if (!str) return 0;
  return new Blob([str]).size;
};

var FULL_DAY_PATTERN = 'EEEE, d MMMM yyyy';
var DB_INVERT_HOUR_DATE_PATTERN = 'dd-MM-yyyy kk:mm';
var DATE_PATTERN = 'dd-MM-yyyy';
var DB_DATE_PATTERN = 'yyyy-MM-dd';
var DB_HOUR_DATE_PATTERN = 'yyyy-MM-dd kk:mm';
var SHORT_DAY_PATTERN = 'dd MMM yyyy kk:mm'; // Time

var HOUR_PATTERN = 'kk';
var HOUR_MINUTE_PATTERN = 'kk:mm';
var FULL_HOUR_PATTERN = 'kk:mm:ss';
/**
 * Formatea una fecha (por defecto FULL_DAY_PATTERN)
 *
 * @param date Fecha a formatear
 * @param pattern Patrón a aplicar (por defecto FULL_DAY_PATTERN)
 * @returns Fecha formateada
 */

var formatDate = function formatDate(date, pattern) {
  if (pattern === void 0) {
    pattern = FULL_DAY_PATTERN;
  }

  if (!date) return '';
  return format(new Date(date), pattern, {
    locale: es
  });
};
/**
 * Formatea una fecha extrayendo únicamente la hora (solo admite patrones de horas)
 *
 * @param date Fecha a formatear
 * @param pattern Patrón a aplicar (por defecto FULL_HOUR_PATTERN)
 * @returns Fecha formateada
 */


var formatHour = function formatHour(date, pattern) {
  if (pattern === void 0) {
    pattern = FULL_HOUR_PATTERN;
  }

  if (!date) return '';
  return format(new Date(date).getTime(), pattern, {
    locale: es
  });
};
/**
 * Transforma un array de objetos en un objeto cuya key (returnKey) es un array de la propiedad (objKey) elegida
 *
 * @param data Array de datos de entrada
 * @param returnKey Key sobre la que se mapeará el objeto
 * @param objKey Key que actuará para cada valor de array
 * @returns Objeto mapeado
 */


var reduceArrayUnderKey = function reduceArrayUnderKey(data, returnKey, objKey) {
  var _initialResult, _ref;

  if (objKey === void 0) {
    objKey = 'id';
  }

  var initialResult = (_initialResult = {}, _initialResult[returnKey] = [], _initialResult);

  if (!Array.isArray(data) || !returnKey || !objKey) {
    return {};
  }

  return (_ref = data || []) == null ? void 0 : _ref.reduce(function (result, current) {
    if (current[objKey]) {
      result[returnKey] = [].concat(result[returnKey] || [], [current[objKey]]);
    }

    return result;
  }, initialResult);
};
/**
 * Transforma un array de objetos en un objeto mapeado por la key deseada (por defecto 'id')
 *
 * @param data Array de datos de entrada
 * @param key  Key sobre la que se mapeará el objeto
 * @returns Objeto mapeado
 */


var reduceArrayToObj = function reduceArrayToObj(data, key) {
  if (key === void 0) {
    key = 'id';
  }

  return data.reduce(function (result, current) {
    var _extends2;

    return _extends({}, result, (_extends2 = {}, _extends2[current[key]] = current, _extends2));
  }, {});
};
/**
 * Filtra un array de objetos por el valor de la key onKey (por defacto 'id') y lo transforma en un objeto mapeado por la id
 *
 * @param data Array de datos de entrada
 * @param value Valor para filtrar el array
 * @param onKey Key de cada item del array para comparar el valor
 * @returns Objeto mapeado y filtrado
 */


var pickAndReduce = function pickAndReduce(data, value, onKey) {
  if (onKey === void 0) {
    onKey = 'id';
  }

  return reduceArrayToObj(data.filter(function (item) {
    return item[onKey] === value;
  }));
};
/* eslint-disable */


var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var notEmptyStringRegex = /.*[^ ].*/;
/**
 * Sanitiza el código contra ataques XSS
 *
 * @param source Elemento o cadena de texto a sanitizar
 * @returns Object Secure html
 */

var sanitize = function sanitize(source) {
  return {
    __html: DOMPurify.sanitize(source)
  };
};

export { DATE_PATTERN, DB_DATE_PATTERN, DB_HOUR_DATE_PATTERN, DB_INVERT_HOUR_DATE_PATTERN, FULL_DAY_PATTERN, FULL_HOUR_PATTERN, HOUR_MINUTE_PATTERN, HOUR_PATTERN, SHORT_DAY_PATTERN, base64ExcelDownload, buildFormData, capitalize, capitalizePhrase, cleanEmptyFields, dataURLtoFile, ellipsis, emailRegex, emptyValue, fileBlobDownload, fileDownload, fileLinkDownload, filesSizeExceeded, formatCurrency, formatDate, formatHour, getFilesSize, getStringSize, nonSpaceEllipsis, notEmptyStringRegex, openBlobFile, pickAndReduce, pipeStrings, prepareBase64, reduceArrayToObj, reduceArrayUnderKey, replaceURLParams, sanitize, useFetch, useFormError, visualizeFile, wrongArray, wrongType };